import { Separator } from '@/components/ui/separator';
import { SidebarNav } from '@/components/ui/sidebar-nav';
import { Outlet } from 'react-router-dom';

export function TabletsLayout() {
  return (
    <>
      <h1 className="text-3xl font-bold">Tablet Control</h1>
      <Separator className="my-6" />

      <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 pb-4">
        <aside className="lg:w-1/5">
          <SidebarNav
            items={[
              { href: '/tablets/groups', title: 'Groups' },
              { href: '/tablets/list', title: 'Tablets' },
            ]}
          />
        </aside>
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </>
  );
}
